// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"16603536","726":"eb52d6d0"}[chunkId] + ".chunk.js";
};